import React, { useState, useEffect, forwardRef, memo, useMemo } from 'react'
import { Heading, Box, Text } from 'grommet'
import styled from 'styled-components'
import {
  closestCenter,
  DndContext,
  DragOverlay,
  // PointerSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import ListItem from './ListItem'
import MainInput from './MainInput'
import { useDispatch, useSelector } from 'react-redux'
import {
  setChoices,
  setMode,
  changeKeyText,
  setWeightOn,
  // toggleMute,
  // setFilteredChoices,
} from '../../redux/homepage/actions'
import { displayListModal } from '../../redux/modal/actions'
import TooltipButton from '../Button/TooltipButton'
import {
  List,
  CheckboxSelected,
  Refresh,
  More,
  View,
  ClearOption,
  Sync,
  Checkbox,
  // ChapterAdd,
  // Volume,
  // VolumeMute,
} from 'grommet-icons'
import MoreButton from '../Button/MoreButton'
import ToolType from '../../utils/toolType'
import MenuIcon from '../MenuIcon'
// import ChoicesListButton from '../Button/ChoicesListButton'
// import LoadSaveButton from '../Button/LoadSaveButton'
import { device } from '../../theme/device'
// import Profiler from '../ReactProfiler'
import { FixedSizeList, areEqual } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { CustomScrollbars } from '../CustomScrollbars'
import { useHideInput } from '../../contextHook/hideInput'
import { useRoverFocus } from '../../hook/useRoverFocus'
// import { useWindowSize } from '../../hook/useWindowSize'
import { useGeneralModal } from '../../contextHook/generalModal'
// import { addNewTabData } from '../../redux/common/actions'
import { displayModifyTitleModal } from '../../redux/modal/actions'
import InputLength from '../Common/InputLength'
import { setIsEditing } from '../../redux/turntable/actions'

const Container = styled(Box)`
  /* border-radius: 25px; */
  /* border-radius: 25px 25px 0 0; */
  border-radius: 2rem;
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  min-height: 0px;
  padding: 0.8rem 2rem 0;
  height: 58.6rem;
  background-color: ${props => props.theme.global.colors.baseBackground};
  @media ${device.medium} {
    padding: 0.8rem 0.8rem 0;
  }
`

// const ListButton = styled(Button)`
//   border: 3px solid ${props => props.theme.global.colors.secondary};
//   padding: 0 1rem;
//   color: ${props => props.theme.global.colors.secondary};
//   border-radius: 5px;
// `

// const ClearButton = styled(Button)`
//   border: 3px solid ${props => props.theme.global.colors.reject};
//   padding: 0 1rem;
//   color: ${props => props.theme.global.colors.reject};
//   border-radius: 5px;
// `

const Separator = styled.hr`
  background-color: transparent;
  border-top: 3px dashed ${props => props.theme.global.colors.border};
  margin: 1rem 5rem;
`

const AutoSizerBox = styled.div`
  flex: 1 1 auto;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  /* -webkit-touch-callout: none; */
`

// const ItemsBox = styled(Box)`
//   &::-webkit-scrollbar {
//     width: 5px !important;
//   }
//   &::-webkit-scrollbar-track {
//     background: white !important;
//   }
//   /* Handle */
//   &::-webkit-scrollbar-thumb {
//     background: ${props => props.theme.global.colors.scrollbar} !important;
//   }
// `

const NoWrapText = styled(Text)`
  white-space: pre;
  font-weight: 500;
`

// const HideButtonBox = styled(Box)`
//   @media ${device.dirChange} {
//     display: none;
//   }
// `

const Row = memo(
  ({ data: { data, inputFocus, weightFocus }, index, style }) => {
    //memo when scrolling but not clicked
    const item = data[index]
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: index.toString() })
    const newStyle = {
      ...style,
      height: style.height - 6,
      transform: CSS.Transform.toString(transform),
      transition,
      zIndex: isDragging ? 100 : 'auto',
      opacity: isDragging ? 0 : 1,
      // touchAction: 'none',
      // userSelect: 'none',
    }

    return (
      // <div style={style}>
      <ListItem
        ref={setNodeRef}
        name={item.name}
        count={item.count}
        filtered={item.filtered}
        weight={item.weight}
        image={item.data}
        inputFocus={inputFocus}
        weightFocus={weightFocus}
        // key={`${inputKeyText}${index}`}
        index={index}
        style={newStyle}
        attributes={attributes}
        listeners={listeners}
      />
    )
    // </div>
  },
  areEqual,
)

const innerElementType = forwardRef(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      ...style,
      paddingBottom: 6,
    }}
    {...rest}
  />
))

const Inputs = () => {
  const choices = useSelector(state => state.main.choices)
  const inputKeyText = useSelector(state => state.main.inputKeyText)
  const weightOn = useSelector(state => state.main.weightOn)
  const { websiteMode } = useSelector(state => state.common)
  const [disabledEnableInput, setDisabledEnableInput] = useState(true)
  const [disabledResetCount, setDisabledResetCount] = useState(true)
  const [activeId, setActiveId] = useState(null)
  const { setHiding } = useHideInput()
  const inputFocus = useRoverFocus(choices.length)
  const weightFocus = useRoverFocus(choices.length)
  // const windowSize = useWindowSize()
  // const COLLAPSE_WIDTH = 420
  const { setConfirmModal } = useGeneralModal()
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 10,
      },
    }),

    // useSensor(PointerSensor),
  )

  // const muteState = useSelector(state => state.main.mute)
  const dispatch = useDispatch()
  // const [mute, setMute] = React.useState(muteState)

  useEffect(() => {
    if (choices) {
      let tempDisabledEnableInput = true
      let tempDisabledResetCount = true
      for (let choice of choices) {
        if (choice.filtered === true) {
          tempDisabledEnableInput = false
        }
        if (choice.count > 0) {
          tempDisabledResetCount = false
        }
      }
      if (tempDisabledEnableInput !== disabledEnableInput) {
        setDisabledEnableInput(tempDisabledEnableInput)
      }

      if (tempDisabledResetCount !== disabledResetCount) {
        setDisabledResetCount(tempDisabledResetCount)
      }
    }
  }, [choices])

  const shuffle = () => {
    let arra1 = choices.slice(0)
    let ctr = arra1.length
    let temp
    let index

    // While there are elements in the array
    while (ctr > 0) {
      // Pick a random index
      index = Math.floor(Math.random() * ctr)
      // Decrease ctr by 1
      ctr--
      // And swap the last element with it
      temp = arra1[ctr]
      arra1[ctr] = arra1[index]
      arra1[index] = temp
    }
    dispatch(setChoices(arra1.slice(0)))
    dispatch(changeKeyText(0))
  }

  const enableAllInputs = enabled => {
    const filteredValue = enabled ? false : true
    const array = choices.slice(0)

    for (let choice of array) {
      choice.filtered = filteredValue
    }

    dispatch(setChoices(array.slice(0)))
    dispatch(changeKeyText(0))
  }

  const resetAllCounts = () => {
    const array = choices.slice(0)

    for (let choice of array) {
      choice.count = 0
    }

    dispatch(setChoices(array.slice(0)))
    dispatch(changeKeyText(0))
  }

  const menuItems = [
    // {
    //   label: <NoWrapText>New Wheel Tab</NoWrapText>,
    //   icon: <MenuIcon icon={<ChapterAdd color="secondary" size="small" />} />,
    //   disabled: tabsData.length > 3,
    //   onClick: () => {
    //     dispatch(addNewTabData('main'))
    //     if (!switchedTab) {
    //       setNoActionModal({
    //         title: 'Note*',
    //         message:
    //           'Only the data of this wheel tab is kept/shared when you visit next time/share wheel.',
    //       })
    //       setSwitchedTab(true)
    //     }
    //   },
    // },
    {
      label: <NoWrapText>Modify Title & Desc.</NoWrapText>,
      icon: (
        <MenuIcon
          icon={
            <Text color="secondary" size="1.8rem">
              T
            </Text>
          }
        />
      ),
      onClick: () => {
        dispatch(displayModifyTitleModal(true))
      },
    },
    {
      label: <NoWrapText>{weightOn ? 'Disable' : 'Enable'} Weight</NoWrapText>,
      icon: (
        <MenuIcon
          icon={
            <Text color="secondary" size="1.8rem">
              W
            </Text>
          }
        />
      ),
      onClick: () => {
        dispatch(setWeightOn(!weightOn))
      },
    },
    // {
    //   label: <NoWrapText>Shuffle</NoWrapText>,
    //   icon: <MenuIcon icon={<Sync color="secondary" size="small" />} />,
    //   onClick: () => shuffle(),
    // },
    {
      label: (
        <NoWrapText>{`${
          disabledEnableInput ? 'Disable' : 'Enable'
        } All Inputs`}</NoWrapText>
      ),
      icon: (
        <MenuIcon
          icon={
            disabledEnableInput ? (
              <Checkbox color="secondary" size="small" />
            ) : (
              <CheckboxSelected color="secondary" size="small" />
            )
          }
        />
      ),
      // disabled: disabledEnableInput,
      onClick: () => enableAllInputs(disabledEnableInput ? false : true),
    },
    {
      label: <NoWrapText>Reset All Counts</NoWrapText>,
      icon: <MenuIcon icon={<Refresh color="secondary" size="small" />} />,
      disabled: disabledResetCount,
      onClick: () => resetAllCounts(),
    },
    {
      label: <NoWrapText>Remove All Inputs</NoWrapText>,
      icon: <MenuIcon icon={<ClearOption color="reject" size="small" />} />,
      onClick: () => {
        setConfirmModal({
          title: 'Remove All Inputs?',
          message:
            'All the current inputs will be removed. If you want to keep the inputs, please save it before proceed.',
          action: () => {
            dispatch(setChoices([]))
            dispatch(setMode(0))
          },
        })
      },
    },
  ]

  const handleDragStart = event => {
    setActiveId(event.active.id)
    dispatch(setIsEditing(true))
  }

  const sortedChoicesIds = useMemo(
    () => choices.map((item, index) => index.toString()),
    [choices],
  )

  const handleDragEnd = event => {
    setActiveId(null)
    dispatch(setIsEditing(false))
    const { active, over } = event
    if (active.id !== over.id) {
      const oldIndex = parseInt(active.id)
      const newIndex = parseInt(over.id)
      const newChoices = arrayMove(choices, oldIndex, newIndex)
      dispatch(setChoices(newChoices, false))
      dispatch(changeKeyText(0))
    }
  }

  const handleDragCancel = event => {
    setActiveId(null)
  }
  let draggedChoice = null
  if (activeId) draggedChoice = choices[parseInt(activeId)]

  const shareEditingMode = websiteMode === 'ShareEditingMode'

  // if (windowSize.width < COLLAPSE_WIDTH) {
  //   menuItems.splice(1, 0, {
  //     label: <NoWrapText>View/Import Inputs</NoWrapText>,
  //     icon: <MenuIcon icon={<List color="secondary" size="small" />} />,
  //     onClick: () => dispatch(displayListModal(ToolType.PICKER_WHEEL)),
  //   })
  // }
  const filteredLength = choices.filter(choice => !choice.filtered).length
  const unfilteredLength = choices.length
  return (
    // <ResponsiveContext.Consumer>
    //   {size => (
    <Container
      width="50rem"
      // border={{
      //   color: 'border',
      //   size: '.3rem',
      //   style: 'solid',
      //   side: 'all',
      // }}
      align="stretch"
      // tabsShown={tabsData.length > 1}
      // flex={true}
    >
      <Box
        direction="row"
        justify="between"
        align="center"
        margin={{ top: '.5rem' }}
      >
        <Box direction="row" align="center" gap=".6rem">
          <Heading level={3} alignSelf="center" margin={{ vertical: '0px' }}>
            INPUTS
          </Heading>
          {choices.length > 0 && (
            <InputLength
              length={
                filteredLength === unfilteredLength
                  ? unfilteredLength
                  : `${filteredLength}/${unfilteredLength}`
              }
            />
          )}
        </Box>

        <Box direction="row" gap=".5rem">
          {/* <HideButtonBox> */}

          <TooltipButton
            icon={<View color="iconDarkLight" />}
            clicked={() => {
              setHiding(true)
            }}
            message="Hide"
            position="top"
            color=""
            padding=".8rem"
          />
          <TooltipButton
            icon={<Sync color="iconDarkLight" size="22px" />}
            clicked={shuffle}
            message="Shuffle"
            position="top"
            padding=".9rem"
            // color="iconDark"
          />
          {/* </HideButtonBox> */}
          {/* {!shareEditingMode && <LoadSaveButton page="main" />} */}

          {/* <ChoicesListButton page="main" /> */}
          {/* {windowSize.width > COLLAPSE_WIDTH && ( */}
          <TooltipButton
            icon={<List color="secondary" size="small" />}
            clicked={() => dispatch(displayListModal(ToolType.PICKER_WHEEL))}
            message="View/Import Inputs"
            position="top"
            color="secondary"
          />
          {/* )} */}

          <MoreButton
            menuItems={menuItems}
            icon={<More color="iconDarkLight" />}
            content="More"
          />
        </Box>
      </Box>
      <MainInput />
      <Separator />
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        // modifiers={[restrictToVerticalAxis]}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
        onDragCancel={handleDragCancel}
      >
        <AutoSizerBox>
          <AutoSizer>
            {({ height, width }) => (
              <SortableContext
                items={sortedChoicesIds}
                strategy={verticalListSortingStrategy}
              >
                <FixedSizeList // use windowing to reduce multiple lists render time
                  height={435}
                  width={width}
                  // width={width - 6} //remove scrollbars width
                  itemSize={46}
                  innerElementType={innerElementType}
                  outerElementType={CustomScrollbars}
                  itemCount={choices.length}
                  itemData={{
                    data: choices,
                    inputFocus,
                    weightFocus,
                  }}
                  itemKey={(index, data) => `${inputKeyText}${index}`}
                  // outerRef={provided.innerRef}
                >
                  {Row}
                </FixedSizeList>
              </SortableContext>
            )}
          </AutoSizer>
        </AutoSizerBox>

        {!!activeId ? (
          <DragOverlay adjustScale={false}>
            <ListItem
              name={draggedChoice?.name}
              count={draggedChoice?.count}
              filtered={draggedChoice?.filtered}
              weight={draggedChoice?.weight}
              isDragging={true}
            />
          </DragOverlay>
        ) : null}
      </DndContext>
    </Container>
    //   )}
    // </ResponsiveContext.Consumer>
  )
}

export default memo(Inputs)
